import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { LocalizationContext } from '../../hoc/Localization';
import { SettingsContext } from '../../hoc/Settings';
import BlogBody from '../../components/Blog/BlogBody';
import { getCareersArticle } from '../../utils/directory';
import styles from './styles.less';

const Careers = ({ seeMoreRoute, category }) => {
  const [blog, setBlog] = React.useState();

  const {
    domainSettings: { blogCountry },
  } = React.useContext(SettingsContext);
  const { t, blogLocale } = React.useContext(LocalizationContext);

  React.useEffect(() => {
    getCareersArticle(blogCountry, blogLocale).then(res => {
      setBlog({ data: res });
    });
  }, [blogLocale]);

  return (
    <>
      <Head>
        <title>{t('meta.careers.title')}</title>
        <meta name="description" content={t('meta.careers.description')} />
      </Head>
      {blog && (
        <div className={styles.careerSection}>
          <div className={styles.head}>
            <h1>{t('meta.careers.title')}</h1>
          </div>
          <BlogBody blog={blog} category={category} seeMoreRoute={seeMoreRoute} />
        </div>
      )}
    </>
  );
};

Careers.propTypes = {
  category: PropTypes.string,
  seeMoreRoute: PropTypes.string,
};

Careers.defaultProps = {
  category: '',
  seeMoreRoute: '',
};

Careers.getInitialProps = async () => ({});

export default Careers;
